// extracted by css-extract-rspack-plugin
export default {"UserCard":"styles-module__UserCard"};